import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Chat = props => {
  return (
    <SvgIcon {...props} width="26.672" height="26.585" viewBox="0 0 26.672 26.585">
      <g transform="translate(-0.5 -0.5)">
        <path
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M38.25,27.89h2.484V39.529h-2L38.2,41.894a.567.567,0,0,1-1.077.1l-1.056-2.484H25V31.066"
          transform="translate(-14.063 -15.756)"
        />
        <path
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M22.908,14.146H9.033L5.555,17.77a.638.638,0,0,1-1.064-.236L3.327,14.146H1V1H22.908Z"
        />
        <line
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x2="17"
          transform="translate(3 3.797)"
        />
        <line
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x2="17"
          transform="translate(3 7.797)"
        />
        <line
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          x2="12.732"
          transform="translate(3.484 10.523)"
        />
      </g>
    </SvgIcon>
  );
};

export default Chat;
